interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600 uppercase mb-3">
          <span className="w-6 h-px bg-primary-400"></span>
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl leading-snug">{title}</h2>
      {desc && <p className="mt-3 text-foreground-600 leading-relaxed text-sm md:text-base">{desc}</p>}
    </div>
  );
}